export const experienceData = [
  {
    place: "Abra",
    title: "DevOps Engineer",
    years: "2025–Present",
    technologies: ["DevOps", "CI/CD", "Cloud", "Automation"],
    bullets: [],
  },
  {
    place: "Elbit Systems",
    title: "Software Developer",
    years: "2022–2024",
    technologies: ["Jenkins", "Python", "React", "Node.js"],
    bullets: [
      "Implemented Jenkins pipelines for automated configuration auditing with Python, reducing manual comparison work by several hours per week and improving compliance visibility.",
      "Built automated license-usage monitoring for Jira/Confluence using Python + Jenkins, sending weekly alerts and proactively preventing license overages.",
      "Optimized scheduled reporting pipelines, improving operational transparency for managers and DevOps teams.",
      "Developed internal tools and Jira/Confluence plugins (React, Node.js, Python) to streamline workflows and improve team efficiency.",
    ],
  },
  {
    place: "Rescue Anxiety App",
    title: "Frontend Developer (Volunteer)",
    years: "2024",
    technologies: ["React Native", "Redux"],
    bullets: [
      "Contributed to the development of a React Native application to support users with anxiety attacks.",
    ],
  },
];
